import type { IAppConfig } from "../../store/interfaces/configInterface";
import type { ITriveltaProductsConfig } from "../../store/interfaces/productsInterface";

export function mergeV2Localization(
  appConfig: IAppConfig | undefined,
  platformConfigV2: ITriveltaProductsConfig | null | undefined,
): IAppConfig | undefined {
  if (!appConfig || !platformConfigV2?.localization) return appConfig;

  return {
    ...appConfig,
    localization: platformConfigV2.localization,
  };
}
